// SETTINGS V2 atom — SCheck. ARIA checkbox on a native <button> —
// @radix-ui/react-checkbox is NOT installed and must not be added (§1/§8).
// Port of settings-kit.jsx SCheck (lines 105-116), made interactive.
import React from "react";

export interface SCheckProps {
  on: boolean;
  onToggle: (next: boolean) => void;
  label: string;
  disabled?: boolean;
}

const SCheck: React.FC<SCheckProps> = ({ on, onToggle, label, disabled }) => (
  <button
    type="button"
    role="checkbox"
    aria-checked={on}
    disabled={disabled}
    onClick={() => onToggle(!on)}
    style={{
      display: "flex",
      alignItems: "center",
      gap: 9,
      fontSize: 13,
      color: "var(--ink-2)",
      cursor: disabled ? "default" : "pointer",
      opacity: disabled ? 0.6 : 1,
      background: "transparent",
      border: 0,
      padding: 0,
      textAlign: "left",
      fontFamily: "inherit",
    }}
  >
    <span
      style={{
        width: 15,
        height: 15,
        borderRadius: 4,
        flexShrink: 0,
        boxSizing: "border-box",
        border: `1.5px solid ${on ? "var(--mod-accent)" : "var(--border)"}`,
        background: on ? "var(--mod-accent)" : "var(--card)",
        display: "grid",
        placeItems: "center",
      }}
    >
      {on && (
        <svg
          viewBox="0 0 10 10"
          width="9"
          height="9"
          fill="none"
          stroke="#fff"
          strokeWidth="1.8"
          strokeLinecap="round"
        >
          <path d="M2 5.2 L4.2 7.4 L8 3" />
        </svg>
      )}
    </span>
    {label}
  </button>
);

export default SCheck;
